import '../assets/NcSettingsInputText-B-V6Y4MD.css';
import { r as register, g as t44, a as t } from "./_l10n-dinIMiE_.mjs";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { createElementBlock, openBlock, withModifiers, createElementVNode, createCommentVNode, toDisplayString } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
register(t44);
const _sfc_main = {
  name: "NcSettingsInputText",
  props: {
    /**
     * label of the select group element
     */
    label: {
      type: String,
      required: true
    },
    /**
     * hint of the select group input
     */
    hint: {
      type: String,
      default: ""
    },
    /**
     * value of the select group input
     */
    modelValue: {
      type: String,
      default: ""
    },
    /**
     * disabled state of the settings select group input
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * id attribute of the select group element
     */
    id: {
      type: String,
      default: () => "settings-input-text-" + createElementId(),
      validator: (id) => id.trim() !== ""
    }
  },
  emits: [
    "change",
    "input",
    "submit",
    "update:modelValue"
  ],
  data() {
    return {
      submitTranslated: t("Submit")
    };
  },
  computed: {
    /**
     * @return {string}
     */
    idSubmit() {
      return this.id + "-submit";
    }
  },
  methods: {
    onInput(event) {
      this.$emit("input", event);
      this.$emit("update:modelValue", event.target.value);
    },
    onSubmit(event) {
      if (!this.disabled) {
        this.$emit("submit", event);
      }
    },
    onChange(event) {
      this.$emit("change", event);
    }
  }
};
const _hoisted_1 = ["disabled"];
const _hoisted_2 = { class: "input-wrapper" };
const _hoisted_3 = ["for"];
const _hoisted_4 = ["id", "value", "disabled"];
const _hoisted_5 = ["id", "value"];
const _hoisted_6 = {
  key: 0,
  class: "hint"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("form", {
    ref: "form",
    disabled: $props.disabled,
    onSubmit: _cache[2] || (_cache[2] = withModifiers((...args) => $options.onSubmit && $options.onSubmit(...args), ["prevent", "stop"]))
  }, [
    createElementVNode("div", _hoisted_2, [
      createElementVNode("label", {
        for: $props.id,
        class: "action-input__label"
      }, toDisplayString($props.label), 9, _hoisted_3),
      createElementVNode("input", {
        id: $props.id,
        type: "text",
        value: $props.modelValue,
        disabled: $props.disabled,
        onInput: _cache[0] || (_cache[0] = (...args) => $options.onInput && $options.onInput(...args)),
        onChange: _cache[1] || (_cache[1] = (...args) => $options.onChange && $options.onChange(...args))
      }, null, 40, _hoisted_4),
      createElementVNode("input", {
        id: $options.idSubmit,
        value: $data.submitTranslated,
        type: "submit",
        class: "action-input__submit"
      }, null, 8, _hoisted_5),
      $props.hint ? (openBlock(), createElementBlock("p", _hoisted_6, toDisplayString($props.hint), 1)) : createCommentVNode("", true)
    ])
  ], 40, _hoisted_1);
}
const NcSettingsInputText = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-3bc2f6a1"]]);
export {
  NcSettingsInputText as N
};
//# sourceMappingURL=NcSettingsInputText-CMBC7DaG.mjs.map
